export const REPORT_LEGAL_MAIL_BODY = `
I am reporting (please check):

[ ] a copyright infringement
[ ] a trademark infringement
[ ] a patent or design infringement
[ ] a violation of smatch terms of use and guidelines
[ ] a different legal issue

Please provide details:

----------------------------------
AuctionKey:`;